import { useEffect } from 'react';
import styled from 'styled-components';
import { Link, useHistory, useLocation } from 'react-router-dom';
import themeGet from '@styled-system/theme-get';
import ReactTooltip from 'react-tooltip';

import Tooltip from '../../../../shared/Tooltip/Tooltip.jsx';
import { EDIT, PREVIEW } from '../../utils/constants';
import {
  EditButton,
  PreviewButton,
  AllCampaignsButton,
} from './NavbarButtons.jsx';
import { getReturnPath } from '../../../broadcastMessages/utils/navigation';

const EditLink = ({ url, onClick }) => {
  return (
    <EditLinkWrapper>
      <EditLinkContainer to={url} onClick={onClick}>
        <EditButton />
      </EditLinkContainer>
    </EditLinkWrapper>
  );
};

const PreviewLink = ({ url, onClick, isDeleted }) => {
  return (
    <PreviewLinkContainer>
      <PreviewButton url={url} onClick={onClick} isDeleted={isDeleted} />
    </PreviewLinkContainer>
  );
};

export const Navbar = ({ id, mode = PREVIEW, children, isDeleted = false }) => {
  const history = useHistory();
  const location = useLocation();
  const isInPlanRouter = location.pathname.startsWith('/campaigns/');
  const prefix = isInPlanRouter ? '/campaigns' : '';
  const linkPath = mode === PREVIEW ? EDIT : PREVIEW;
  const url = `${prefix}/${id}/${linkPath}`;

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  const ModeButton = () => {
    switch (mode) {
      case PREVIEW:
        return <EditLink url={url} />;
      case EDIT:
        return <PreviewLink url={url} isDeleted={isDeleted} />;
      default:
        return null;
    }
  };

  const handleBackClick = () => {
    if (isInPlanRouter) {
      history.push(getReturnPath(location));
      return;
    }

    const searchParams = new URLSearchParams(location.search);
    const from = searchParams.get('from');

    if (from === 'calendar') {
      const returnParams = new URLSearchParams({ view: 'calendar' });
      const cy = searchParams.get('cy');
      const cm = searchParams.get('cm');
      const hf = searchParams.get('hf');
      const bf = searchParams.get('bf');
      if (cy) returnParams.set('cy', cy);
      if (cm !== null && cm !== undefined && cm !== '')
        returnParams.set('cm', cm);
      if (hf) returnParams.set('hf', hf);
      if (bf) returnParams.set('bf', bf);
      history.push(`/?${returnParams}`);
    } else {
      history.push('/');
    }
  };

  return (
    <Container>
      <Tooltip />
      <LinkWrapper>
        <AllCampaignsButton onClick={handleBackClick} />
      </LinkWrapper>
      {children}
      <ModeButton />
    </Container>
  );
};

const Container = styled.div`
  background: ${themeGet('colors.background')};
  margin: 0 10px;
  padding: 10px 0;
  grid-template-columns: repeat(3, 1fr);
  display: grid;
  position: sticky;
  align-items: center;
  top: 0;
  z-index: 3;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
  justify-content: space-between;
`;

const PreviewLinkContainer = styled.div`
  display: flex;
  justify-content: end;
`;

const EditLinkContainer = styled(Link)`
  display: flex;
  justify-content: end;
`;

const LinkWrapper = styled.div`
  display: flex;
`;

const EditLinkWrapper = styled(LinkWrapper)`
  justify-content: end;
`;
